import { api } from 'shared/api'

import { templatesApiSchemas } from './schema'

export const templatesApi = {
  fetch: api.account.createGet({
    url: '/templates/list',
    schemas: templatesApiSchemas.fetch,
  }),
  fetchTemplate: api.account.createGet({
    url: '/templates/data',
    schemas: templatesApiSchemas.fetchTemplate,
  }),
  uninstall: api.account.createPost({
    url: '/templates/uninstall',
    schemas: templatesApiSchemas.uninstall,
  }),
}
